export const config = {
  stemsBasePath: '/stems',
  db: {
    path: process.env.NODE_ENV === 'production' ? 'stems.db' : 'stems_dev.db'
  }
}; 